import { render, staticRenderFns } from "./PfLoanWizard.vue?vue&type=template&id=007d2e56"
import script from "./PfLoanWizard.vue?vue&type=script&lang=js"
export * from "./PfLoanWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports